export default "__VITE_ASSET__D97F4yEG__"